import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../auth/Login";
import BehavioralDistribution from "./BehavioralDistribution";
const BehavioralDistributionIndex = () => {
  return (
    <div>
      <AuthenticatedTemplate>
        <BehavioralDistribution />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default BehavioralDistributionIndex;
